import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { ArrowDb } from '../redux/arrowDbSlice';

const useArrowDbsByCard = (cardId: string | undefined) : [string[], ArrowDb[]] => {
  const arrowDb = useSelector((state: RootState) => state.arrowDb);
  const ids = Object.keys(arrowDb.arrows).filter(id => arrowDb.arrows[id].fromId === cardId || arrowDb.arrows[id].toId === cardId);
  const arrows = ids.map(id => arrowDb.arrows[id]);
  return [ids, arrows];
}

export default useArrowDbsByCard;
